import React from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import SearchBar from './SearchBar'
import ClientActions from '../../store/clientRedux'

const SearchClients = () => {

    const dispatch = useDispatch();

    const performSearch = searchString => {
        if (searchString.toUpperCase().startsWith('ID-')) {
            let splits = searchString.split('-')
            let id = splits[1]
            let taxYear = parseInt(splits[2], 10)
            if (splits.length === 3 && id && splits[2] && splits[2].length === 2 && !isNaN(taxYear) && taxYear > 0) {
                dispatch(push(`/filedreturn/${id}/year/${splits[2]}`))
            } else {
                const encodedString = encodeURIComponent(searchString.trim());
                dispatch(ClientActions.searchClients(encodedString))
                dispatch(push(`/clients/search?query=${encodedString}`))
            }
        }
        else if (searchString.toUpperCase().startsWith('VMID-')) {
            let splits = searchString.split('-')
            let vmId = splits[1]
            let taxYear = parseInt(splits[2], 10)
            if (splits.length === 3 && vmId && splits[2] && splits[2].length === 2 && !isNaN(taxYear) && taxYear > 0) {
                dispatch(push(`/filedreturns/${vmId}/year/${splits[2]}`))
            } else {
                const encodedString = encodeURIComponent(searchString.trim());
                dispatch(ClientActions.searchClients(encodedString))
                dispatch(push(`/clients/search?query=${encodedString}`))
            }
        }
        else {
            const encodedString = encodeURIComponent(searchString.trim());
            dispatch(ClientActions.searchClients(encodedString))
            dispatch(push(`/clients/search?query=${encodedString}`))
        }
    }

    return <SearchBar elementId='search-bar' placeholderKey='Search.Placeholder' performSearch={performSearch} />
}

export default SearchClients